import { gql } from '../../gql';

export const GET_SURVEY_TEMPLATE_IDS = gql(`
  query GetSurveyTemplateIds(
    $where: JSON
    $orderBy: [ColumnOrder]
    $limit: Int
    $offset: Int
  ) {
    waterHazardSurveyTemplates(
      where: $where
      orderBy: $orderBy
      limit: $limit
      offset: $offset
    ) {
      id
    }
  }
`);

export const GET_SURVEY_TEMPLATES = gql(`
  query GetSurveyTemplates(
    $where: JSON
    $orderBy: [ColumnOrder]
    $limit: Int
    $offset: Int
  ) {
    waterHazardSurveyTemplates(
      where: $where
      orderBy: $orderBy
      limit: $limit
      offset: $offset
    ) {
      id
      name
      description
      instructions
      otherHazardsQuestion
      protectedQuestion
      items {
        waterHazardId
        displayOrder
        waterHazard {
          id
          name
          hazardLevel
        }
      }
    }
  }
`);

export const CREATE_SURVEY_TEMPLATE = gql(`
  mutation CreateSurveyTemplate($input: WaterHazardSurveyTemplateInput!) {
    createWaterHazardSurveyTemplate(input: $input) {
      id
      name
      description
      instructions
      otherHazardsQuestion
      protectedQuestion
    }
  }
`);

export const UPDATE_SURVEY_TEMPLATE = gql(`
  mutation UpdateSurveyTemplate(
    $templateId: ID!
    $input: WaterHazardSurveyTemplateInput!
  ) {
    updateWaterHazardSurveyTemplate(templateId: $templateId, input: $input) {
      id
      name
      description
      instructions
      otherHazardsQuestion
      protectedQuestion
    }
  }
`);

export type SurveyTemplateItem = {
  id: string;
  name: string;
  description: string;
  instructions: string | null;
  otherHazardsQuestion: boolean;
  protectedQuestion: boolean;
  items: {
    waterHazardId: string;
    displayOrder: number;
    waterHazard: {
      id: string;
      name: string;
      hazardLevel: string;
    };
  }[];
};
